/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from '../API';
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getConnectionsHeadcount = /* GraphQL */ `query GetConnectionsHeadcount(
  $endDate: String
  $isPoweruser: Boolean
  $leaderLogin: String!
  $startDate: String
  $viewerLogin: String
) {
  getConnectionsHeadcount(
    endDate: $endDate
    isPoweruser: $isPoweruser
    leaderLogin: $leaderLogin
    startDate: $startDate
    viewerLogin: $viewerLogin
  ) {
    displayName
    leaderEmployeeId
    leaderLogin
    metricMonth
    metricName
    metricValue
    scenario
  }
}
` as GeneratedQuery<APITypes.GetConnectionsHeadcountQueryVariables, APITypes.GetConnectionsHeadcountQuery>;
export const getConnectionsScorecard = /* GraphQL */ `query GetConnectionsScorecard(
  $isPoweruser: Boolean
  $leaderLogin: String!
  $metricPeriod: String!
  $scope: String
  $startDate: String
  $summaryType: String
  $viewerLogin: String
) {
  getConnectionsScorecard(
    isPoweruser: $isPoweruser
    leaderLogin: $leaderLogin
    metricPeriod: $metricPeriod
    scope: $scope
    startDate: $startDate
    summaryType: $summaryType
    viewerLogin: $viewerLogin
  ) {
    displayName
    groupByDimension
    groupByValue
    hasDirectOrgBreakdown
    lastUpdated
    leaderId
    leaderLogin
    metricPeriod
    scope
    summaryType
    themes {
      benchmarkMax
      benchmarkMean
      benchmarkMin
      displayName
      metricId
      metricValue
      missingValueReason
      populationSize
      rangeIndicator
      sampleSize
      theme
      unadjustedMetricValue
      uniqueRespondents
    }
  }
}
` as GeneratedQuery<APITypes.GetConnectionsScorecardQueryVariables, APITypes.GetConnectionsScorecardQuery>;
export const getConnectionsTrends = /* GraphQL */ `query GetConnectionsTrends(
  $isPoweruser: Boolean
  $leaderLogin: String!
  $scope: String
  $summaryType: String
  $theme: String!
  $viewerLogin: String
) {
  getConnectionsTrends(
    isPoweruser: $isPoweruser
    leaderLogin: $leaderLogin
    scope: $scope
    summaryType: $summaryType
    theme: $theme
    viewerLogin: $viewerLogin
  ) {
    benchmarkMax
    benchmarkMean
    benchmarkMin
    metricPeriod
    metricValue
    missingValueReason
    rangeIndicator
    sampleSize
    startDate
  }
}
` as GeneratedQuery<APITypes.GetConnectionsTrendsQueryVariables, APITypes.GetConnectionsTrendsQuery>;
export const getEaPicker = /* GraphQL */ `query GetEaPicker {
  getEaPicker {
    defaultEa {
      department_name_current
      emplid
      employee_assistant_employee_id
      employee_internal_email_address
      employee_name
      job_level_name
      job_title_name
      location_city_name
      location_state_name
      login_name
    }
    options {
      department_name_current
      emplid
      employee_assistant_employee_id
      employee_internal_email_address
      employee_name
      job_level_name
      job_title_name
      location_city_name
      location_state_name
      login_name
    }
  }
}
` as GeneratedQuery<APITypes.GetEaPickerQueryVariables, APITypes.GetEaPickerQuery>;
export const getHeadcountAnnotations = /* GraphQL */ `query GetHeadcountAnnotations($aliases: [String!]!) {
  getHeadcountAnnotations(aliases: $aliases) {
    details {
      name
      value
    }
    highlighted
    key
    notes {
      author
      createdAt
      key
      noteId
      text
      updatedAt
      updatedBy
    }
    tags
  }
}
` as GeneratedQuery<APITypes.GetHeadcountAnnotationsQueryVariables, APITypes.GetHeadcountAnnotationsQuery>;
export const getHeadcountMovements = /* GraphQL */ `query GetHeadcountMovements(
  $from: String!
  $login: String!
  $nextToken: String
  $queryExecutionId: String
  $to: String!
) {
  getHeadcountMovements(
    from: $from
    login: $login
    nextToken: $nextToken
    queryExecutionId: $queryExecutionId
    to: $to
  ) {
    leader
    nextToken
    pollAfterSeconds
    queryExecutionId
    rows {
      candidateid
      costcenterid
      costcentername
      departdate
      desiredstartdate
      direction
      employee_alias
      employeebusinesstitle
      employeefullname
      first_seen_snapshot_day
      is_latest_for_employee
      jobfamilycode
      joblevelname
      jobtitlename
      kind
      last_seen_snapshot_day
      lasthiredate
      locationbuildingcode
      locationcityname
      locationcountryname
      movement_date
      pendingdeparttype
      positionid
      prior_supervisor_alias
      status
      statusv2
      supervisor_alias
      supervisor_name
      teamid
      teamname
    }
    snapshotDay
    status
    totals {
      arrivals
      arrived
      departed
      departures
      external
      internal
      pending
      row_count
    }
  }
}
` as GeneratedQuery<APITypes.GetHeadcountMovementsQueryVariables, APITypes.GetHeadcountMovementsQuery>;
export const getHeadcountRoster = /* GraphQL */ `query GetHeadcountRoster(
  $login: String!
  $nextToken: String
  $queryExecutionId: String
  $snapshotDay: String
) {
  getHeadcountRoster(
    login: $login
    nextToken: $nextToken
    queryExecutionId: $queryExecutionId
    snapshotDay: $snapshotDay
  ) {
    leader
    nextToken
    pollAfterSeconds
    queryExecutionId
    rows {
      costcenterid
      costcentername
      departdate
      desiredstartdate
      employee_alias
      employeebusinesstitle
      employeefullname
      includedinplan
      isbackfilling
      isconfidential
      jobfamilycode
      joblevelname
      jobtitlename
      lasthiredate
      locationairportcode
      locationbuildingcode
      locationcityname
      locationcountryname
      opbudgetyear
      pendingdeparttype
      positionid
      statusv2
      supervisor_alias
      supervisor_name
      teamid
      teamname
    }
    snapshotDay
    status
    totals {
      backfills
      confidential_positions
      employees
      open_positions
      pending_departures
      pending_starts
      row_count
    }
  }
}
` as GeneratedQuery<APITypes.GetHeadcountRosterQueryVariables, APITypes.GetHeadcountRosterQuery>;
export const getHeadcountSummary = /* GraphQL */ `query GetHeadcountSummary(
  $login: String!
  $nextToken: String
  $queryExecutionId: String
  $snapshotDay: String
) {
  getHeadcountSummary(
    login: $login
    nextToken: $nextToken
    queryExecutionId: $queryExecutionId
    snapshotDay: $snapshotDay
  ) {
    leader
    nextToken
    pollAfterSeconds
    queryExecutionId
    rows {
      approved_plan
      costcenterid
      costcentername
      employees
      gap_to_plan
      open_reqs
      pending_departures
      pending_starts
      reportsto_hierarchy
      supervisor_alias
      supervisor_name
      teamid
      teamname
    }
    snapshotDay
    status
    totals {
      approved_plan
      employees
      gap_to_plan
      open_reqs
      pending_departures
      pending_starts
      team_count
    }
  }
}
` as GeneratedQuery<APITypes.GetHeadcountSummaryQueryVariables, APITypes.GetHeadcountSummaryQuery>;
export const getHolidaysByYear = /* GraphQL */ `query GetHolidaysByYear($country: String, $year: String!) {
  getHolidaysByYear(country: $country, year: $year) {
    country
    createdAt
    daysClosed
    isActive
    reason
    updatedAt
    week
    year
  }
}
` as GeneratedQuery<APITypes.GetHolidaysByYearQueryVariables, APITypes.GetHolidaysByYearQuery>;
export const getIntake = /* GraphQL */ `query GetIntake($intakeId: ID!) {
  getIntake(intakeId: $intakeId) {
    applicationId
    applicationName
    assigneeAlias
    assigneeName
    attachmentFileName
    attachmentS3Key
    businessNeed
    createdAt
    createdBy
    currentWorkaround
    description
    hasMyUpvote
    intakeId
    owningTeam
    requestorAlias
    requestorName
    status
    stories {
      authorAlias
      authorName
      createdAt
      storyId
      storyText
      updatedAt
    }
    title
    updatedAt
    updatedBy
    upvoteCount
    upvoters {
      alias
      name
      votedAt
    }
    usersImpacted
  }
}
` as GeneratedQuery<APITypes.GetIntakeQueryVariables, APITypes.GetIntakeQuery>;
export const getKingpinGoalSnapshot = /* GraphQL */ `query GetKingpinGoalSnapshot($goalId: String!) {
  getKingpinGoalSnapshot(goalId: $goalId) {
    categoryL1
    categoryL2
    date
    description
    fetchedAt
    goalId
    metricValue
    modified
    modifiedBy
    name
    owners
    secondaryOwners
    snapshotMonth
    soWhat
    status
    statusComments
    tags
  }
}
` as GeneratedQuery<APITypes.GetKingpinGoalSnapshotQueryVariables, APITypes.GetKingpinGoalSnapshotQuery>;
export const getMcpConfig = /* GraphQL */ `query GetMcpConfig($id: String!) {
  getMcpConfig(id: $id) {
    category
    contacts {
      alias
      role
    }
    createdAt
    createdBy
    description
    features {
      description
      icon
      title
    }
    id
    isFeatured
    logoConfig {
      logoType
      s3Location {
        bucket
        contentType
        key
        region
      }
      selectedLogoName
      uploadedFileName
    }
    name
    resources {
      label
      type
      url
    }
    terminalCommands {
      command
      method
      os
    }
    toolGroups {
      category
      tools {
        description
        name
      }
    }
    updatedAt
    updatedBy
  }
}
` as GeneratedQuery<APITypes.GetMcpConfigQueryVariables, APITypes.GetMcpConfigQuery>;
export const getProjectDetailsByAlias = /* GraphQL */ `query GetProjectDetailsByAlias(
  $alias: String!
  $fromWeek: String
  $toWeek: String
) {
  getProjectDetailsByAlias(
    alias: $alias
    fromWeek: $fromWeek
    toWeek: $toWeek
  ) {
    alias
    allocations {
      fte
      percent
      projectId
    }
    confirmed
    createdAt
    note
    updatedAt
    week
    year
  }
}
` as GeneratedQuery<APITypes.GetProjectDetailsByAliasQueryVariables, APITypes.GetProjectDetailsByAliasQuery>;
export const getProjectVoters = /* GraphQL */ `query GetProjectVoters(
  $cycleId: ID!
  $kind: ProjectVoteKind
  $limit: Int
  $offset: Int
  $projectGid: ID!
) {
  getProjectVoters(
    cycleId: $cycleId
    kind: $kind
    limit: $limit
    offset: $offset
    projectGid: $projectGid
  ) {
    hasMore
    items {
      alias
      name
      votedAt
    }
    projectGid
    totalCount
    voteCount
  }
}
` as GeneratedQuery<APITypes.GetProjectVotersQueryVariables, APITypes.GetProjectVotersQuery>;
export const getQuickSightEmbedUrl = /* GraphQL */ `query GetQuickSightEmbedUrl($dashboardId: String!) {
  getQuickSightEmbedUrl(dashboardId: $dashboardId)
}
` as GeneratedQuery<APITypes.GetQuickSightEmbedUrlQueryVariables, APITypes.GetQuickSightEmbedUrlQuery>;
export const getVoteCycle = /* GraphQL */ `query GetVoteCycle($cycleId: ID!) {
  getVoteCycle(cycleId: $cycleId) {
    bannerHours
    budget
    closesAt
    createdAt
    createdBy
    cycleId
    isOpen
    name
    opensAt
    portfolios {
      isMain
      portfolioGid
      portfolioLabel
    }
    process
    status
    updatedAt
    updatedBy
    year
  }
}
` as GeneratedQuery<APITypes.GetVoteCycleQueryVariables, APITypes.GetVoteCycleQuery>;
export const getWeekConfigByLeader = /* GraphQL */ `query GetWeekConfigByLeader($leaderAlias: String!, $year: String) {
  getWeekConfigByLeader(leaderAlias: $leaderAlias, year: $year) {
    createdAt
    isActive
    leaderAlias
    updatedAt
    updatedBy
    week
    year
  }
}
` as GeneratedQuery<APITypes.GetWeekConfigByLeaderQueryVariables, APITypes.GetWeekConfigByLeaderQuery>;
export const listAllPeople = /* GraphQL */ `query ListAllPeople($activeOnly: Boolean) {
  listAllPeople(activeOnly: $activeOnly) {
    alias
    createdAt
    isActive
    level
    name
    reportsTo
    title
    updatedAt
  }
}
` as GeneratedQuery<APITypes.ListAllPeopleQueryVariables, APITypes.ListAllPeopleQuery>;
export const listAllProjects = /* GraphQL */ `query ListAllProjects($activeOnly: Boolean) {
  listAllProjects(activeOnly: $activeOnly) {
    additionalLeaders
    createdAt
    isActive
    isGlobal
    lead
    projectId
    projectName
    targetFte
    type
    updatedAt
  }
}
` as GeneratedQuery<APITypes.ListAllProjectsQueryVariables, APITypes.ListAllProjectsQuery>;
export const listAllReportsUnderLeader = /* GraphQL */ `query ListAllReportsUnderLeader(
  $hierarchy_distance: Int
  $supervisor_login: String!
) {
  listAllReportsUnderLeader(
    hierarchy_distance: $hierarchy_distance
    supervisor_login: $supervisor_login
  ) {
    reports_under_leader {
      data {
        department_name_current
        emplid
        employee_assistant_employee_id
        employee_internal_email_address
        employee_name
        job_level_name
        job_title_name
        location_city_name
        location_state_name
        login_name
      }
    }
  }
}
` as GeneratedQuery<APITypes.ListAllReportsUnderLeaderQueryVariables, APITypes.ListAllReportsUnderLeaderQuery>;
export const listAnnouncements = /* GraphQL */ `query ListAnnouncements {
  listAnnouncements {
    announcement
    announcementCategory {
      id
      label
      labelType
    }
    announcementDate
    announcementLink
    applicationName {
      id
      label
      labelType
    }
    id
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    title
  }
}
` as GeneratedQuery<APITypes.ListAnnouncementsQueryVariables, APITypes.ListAnnouncementsQuery>;
export const listApplicationFavorites = /* GraphQL */ `query ListApplicationFavorites($userAlias: String) {
  listApplicationFavorites(userAlias: $userAlias) {
    applicationId
    id
    userAlias
  }
}
` as GeneratedQuery<APITypes.ListApplicationFavoritesQueryVariables, APITypes.ListApplicationFavoritesQuery>;
export const listApplications = /* GraphQL */ `query ListApplications {
  listApplications {
    applicationLink
    applicationName
    applicationOwnerId
    embeddingEnabled
    fullApplicationDescription
    glAccounts {
      id
      label
      labelType
    }
    hasNonProductionEnvironments
    id
    isFlagship
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    keyDimension {
      id
      label
      labelType
    }
    lastEnhanced {
      id
      label
      labelType
    }
    logoConfig {
      logoType
      s3Location {
        bucket
        contentType
        key
        region
      }
      selectedLogoName
      uploadedFileName
    }
    mcpPath
    nonProductionEnvironments {
      accessLevel {
        id
        label
        labelType
      }
      displayText
      id
      link
    }
    process {
      id
      label
      labelType
    }
    qChatConfig {
      agentUrl
      isEnabled
    }
    scenario {
      id
      label
      labelType
    }
    shortApplicationDescription
    timeGranularity {
      id
      label
      labelType
    }
    toolUI {
      id
      label
      labelType
    }
    urlName
  }
}
` as GeneratedQuery<APITypes.ListApplicationsQueryVariables, APITypes.ListApplicationsQuery>;
export const listConnectionsFreetextResponses = /* GraphQL */ `query ListConnectionsFreetextResponses(
  $isPoweruser: Boolean
  $leaderLogin: String!
  $metricPeriod: String!
  $sentiment: String
  $startDate: String!
  $topic: String
  $viewerLogin: String
) {
  listConnectionsFreetextResponses(
    isPoweruser: $isPoweruser
    leaderLogin: $leaderLogin
    metricPeriod: $metricPeriod
    sentiment: $sentiment
    startDate: $startDate
    topic: $topic
    viewerLogin: $viewerLogin
  ) {
    dataMonth
    questionText
    responseHash
    sentiment
    theme
    topic
    writtenResponse
  }
}
` as GeneratedQuery<APITypes.ListConnectionsFreetextResponsesQueryVariables, APITypes.ListConnectionsFreetextResponsesQuery>;
export const listConnectionsFreetextTopics = /* GraphQL */ `query ListConnectionsFreetextTopics(
  $isPoweruser: Boolean
  $leaderLogin: String!
  $metricPeriod: String!
  $startDate: String
  $viewerLogin: String
) {
  listConnectionsFreetextTopics(
    isPoweruser: $isPoweruser
    leaderLogin: $leaderLogin
    metricPeriod: $metricPeriod
    startDate: $startDate
    viewerLogin: $viewerLogin
  ) {
    metricValue
    responseCount
    sampleSize
    sentiment
    topicId
    topicName
  }
}
` as GeneratedQuery<APITypes.ListConnectionsFreetextTopicsQueryVariables, APITypes.ListConnectionsFreetextTopicsQuery>;
export const listConnectionsLeaders = /* GraphQL */ `query ListConnectionsLeaders(
  $includeInactive: Boolean
  $isPoweruser: Boolean
  $viewerLogin: String
) {
  listConnectionsLeaders(
    includeInactive: $includeInactive
    isPoweruser: $isPoweruser
    viewerLogin: $viewerLogin
  ) {
    displayName
    hasDirectOrgBreakdown
    isActive
    leaderId
    leaderLogin
    level
    orgLogin
    span
  }
}
` as GeneratedQuery<APITypes.ListConnectionsLeadersQueryVariables, APITypes.ListConnectionsLeadersQuery>;
export const listConnectionsQuestionResponses = /* GraphQL */ `query ListConnectionsQuestionResponses(
  $isPoweruser: Boolean
  $leaderLogin: String!
  $metricPeriod: String!
  $startDate: String
  $viewerLogin: String
) {
  listConnectionsQuestionResponses(
    isPoweruser: $isPoweruser
    leaderLogin: $leaderLogin
    metricPeriod: $metricPeriod
    startDate: $startDate
    viewerLogin: $viewerLogin
  ) {
    parentQuestionId
    parentQuestionText
    questionId
    questionText
    responseCount
    responseOptionId
    responseOptionText
    sampleSize
    score
  }
}
` as GeneratedQuery<APITypes.ListConnectionsQuestionResponsesQueryVariables, APITypes.ListConnectionsQuestionResponsesQuery>;
export const listConnectionsScorecards = /* GraphQL */ `query ListConnectionsScorecards(
  $groupByDimension: String
  $isPoweruser: Boolean
  $leaderLogin: String
  $metricPeriod: String
  $scope: String
  $startDate: String
  $summaryType: String
  $viewerLogin: String
) {
  listConnectionsScorecards(
    groupByDimension: $groupByDimension
    isPoweruser: $isPoweruser
    leaderLogin: $leaderLogin
    metricPeriod: $metricPeriod
    scope: $scope
    startDate: $startDate
    summaryType: $summaryType
    viewerLogin: $viewerLogin
  ) {
    displayName
    groupByDimension
    groupByValue
    hasDirectOrgBreakdown
    lastUpdated
    leaderId
    leaderLogin
    metricPeriod
    scope
    summaryType
    themes {
      benchmarkMax
      benchmarkMean
      benchmarkMin
      displayName
      metricId
      metricValue
      missingValueReason
      populationSize
      rangeIndicator
      sampleSize
      theme
      unadjustedMetricValue
      uniqueRespondents
    }
  }
}
` as GeneratedQuery<APITypes.ListConnectionsScorecardsQueryVariables, APITypes.ListConnectionsScorecardsQuery>;
export const listDogmaDetail = /* GraphQL */ `query ListDogmaDetail {
  listDogmaDetail {
    dogma_details {
      data {
        created_date
        manager_login_hierarchy_concat
        manager_name_hierarchy_concat
        resolved_date
        risk_best_practices
        risk_entity_type
        risk_entity_value
        risk_owner_login
        risk_owner_name
        risk_pipeline_name
        risk_rule_id
        risk_severity
        status
        team_name
      }
      metadata {
        last_updated_at
      }
    }
  }
}
` as GeneratedQuery<APITypes.ListDogmaDetailQueryVariables, APITypes.ListDogmaDetailQuery>;
export const listEmployeesByAliases = /* GraphQL */ `query ListEmployeesByAliases($login_aliases: [String]!) {
  listEmployeesByAliases(login_aliases: $login_aliases) {
    data {
      department_name_current
      emplid
      employee_assistant_employee_id
      employee_internal_email_address
      employee_name
      job_level_name
      job_title_name
      location_city_name
      location_state_name
      login_name
    }
  }
}
` as GeneratedQuery<APITypes.ListEmployeesByAliasesQueryVariables, APITypes.ListEmployeesByAliasesQuery>;
export const listEmployeesByNames = /* GraphQL */ `query ListEmployeesByNames($employee_names: [String]!, $records_per_name: Int) {
  listEmployeesByNames(
    employee_names: $employee_names
    records_per_name: $records_per_name
  ) {
    data {
      department_name_current
      emplid
      employee_assistant_employee_id
      employee_internal_email_address
      employee_name
      job_level_name
      job_title_name
      location_city_name
      location_state_name
      login_name
    }
  }
}
` as GeneratedQuery<APITypes.ListEmployeesByNamesQueryVariables, APITypes.ListEmployeesByNamesQuery>;
export const listExecutiveAssistants = /* GraphQL */ `query ListExecutiveAssistants($supervisor_login: String) {
  listExecutiveAssistants(supervisor_login: $supervisor_login) {
    data {
      department_name_current
      emplid
      employee_assistant_employee_id
      employee_internal_email_address
      employee_name
      job_level_name
      job_title_name
      location_city_name
      location_state_name
      login_name
    }
  }
}
` as GeneratedQuery<APITypes.ListExecutiveAssistantsQueryVariables, APITypes.ListExecutiveAssistantsQuery>;
export const listFeedback = /* GraphQL */ `query ListFeedback {
  listFeedback {
    applicationName {
      id
      label
      labelType
    }
    feedback
    feedbackType
    id
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    rating
  }
}
` as GeneratedQuery<APITypes.ListFeedbackQueryVariables, APITypes.ListFeedbackQuery>;
export const listFinanceCalendarEvents = /* GraphQL */ `query ListFinanceCalendarEvents {
  listFinanceCalendarEvents {
    dateTime
    description
    event
    eventId
    scenario
    source
  }
}
` as GeneratedQuery<APITypes.ListFinanceCalendarEventsQueryVariables, APITypes.ListFinanceCalendarEventsQuery>;
export const listGeneralContent = /* GraphQL */ `query ListGeneralContent {
  listGeneralContent {
    content
    id
    name
  }
}
` as GeneratedQuery<APITypes.ListGeneralContentQueryVariables, APITypes.ListGeneralContentQuery>;
export const listHomePageContent = /* GraphQL */ `query ListHomePageContent {
  listHomePageContent {
    applicationBanner {
      action {
        label
        url
      }
      bannerType
      content
      dismissible
      header
      isEnabled
    }
    contactsWidgetContacts {
      contactId
      groupName
      otherContacts {
        contactAlias
        contactName
      }
      primaryContact {
        contactAlias
        contactName
      }
      simLinks {
        name
        url
      }
      slackChannels {
        name
        url
      }
    }
    hasWelcomeContent
    id
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    welcomeContentDetails {
      description
      displayText
      id
      link
      pointOfContact
    }
    welcomeTitle
  }
}
` as GeneratedQuery<APITypes.ListHomePageContentQueryVariables, APITypes.ListHomePageContentQuery>;
export const listIntakes = /* GraphQL */ `query ListIntakes($limit: Int, $offset: Int, $requestorAlias: String) {
  listIntakes(limit: $limit, offset: $offset, requestorAlias: $requestorAlias) {
    hasMore
    items {
      applicationId
      applicationName
      assigneeAlias
      assigneeName
      createdAt
      hasAttachment
      hasMyUpvote
      intakeId
      owningTeam
      requestorAlias
      requestorName
      status
      storyCount
      title
      updatedAt
      upvoteCount
      usersImpacted
    }
    totalCount
  }
}
` as GeneratedQuery<APITypes.ListIntakesQueryVariables, APITypes.ListIntakesQuery>;
export const listKingpinGoals = /* GraphQL */ `query ListKingpinGoals {
  listKingpinGoals {
    createdAt
    goalId
    isActive
    pocAliases
    tier
    tobiasDirectAlias
    updatedAt
  }
}
` as GeneratedQuery<APITypes.ListKingpinGoalsQueryVariables, APITypes.ListKingpinGoalsQuery>;
export const listKingpinSyncHistory = /* GraphQL */ `query ListKingpinSyncHistory($limit: Int) {
  listKingpinSyncHistory(limit: $limit) {
    date
    duration
    errors
    goalsProcessed
  }
}
` as GeneratedQuery<APITypes.ListKingpinSyncHistoryQueryVariables, APITypes.ListKingpinSyncHistoryQuery>;
export const listLabels = /* GraphQL */ `query ListLabels {
  listLabels {
    id
    label
    labelType
  }
}
` as GeneratedQuery<APITypes.ListLabelsQueryVariables, APITypes.ListLabelsQuery>;
export const listMappingColDetails = /* GraphQL */ `query ListMappingColDetails {
  listMappingColDetails {
    col_def {
      data
    }
  }
}
` as GeneratedQuery<APITypes.ListMappingColDetailsQueryVariables, APITypes.ListMappingColDetailsQuery>;
export const listMappingConfig = /* GraphQL */ `query ListMappingConfig {
  listMappingConfig {
    mapping_config {
      data {
        mapping_key
        mapping_name
        target_table
      }
    }
  }
}
` as GeneratedQuery<APITypes.ListMappingConfigQueryVariables, APITypes.ListMappingConfigQuery>;
export const listMappingDetails = /* GraphQL */ `query ListMappingDetails($limit: Int, $offset: Int, $table_name: String) {
  listMappingDetails(limit: $limit, offset: $offset, table_name: $table_name) {
    mapping_details {
      data
    }
    total_count
  }
}
` as GeneratedQuery<APITypes.ListMappingDetailsQueryVariables, APITypes.ListMappingDetailsQuery>;
export const listMappingValidationConfig = /* GraphQL */ `query ListMappingValidationConfig {
  listMappingValidationConfig {
    mapping_validation_config {
      data
    }
  }
}
` as GeneratedQuery<APITypes.ListMappingValidationConfigQueryVariables, APITypes.ListMappingValidationConfigQuery>;
export const listMcpConfigs = /* GraphQL */ `query ListMcpConfigs {
  listMcpConfigs {
    category
    contacts {
      alias
      role
    }
    createdAt
    createdBy
    description
    features {
      description
      icon
      title
    }
    id
    isFeatured
    logoConfig {
      logoType
      s3Location {
        bucket
        contentType
        key
        region
      }
      selectedLogoName
      uploadedFileName
    }
    name
    resources {
      label
      type
      url
    }
    terminalCommands {
      command
      method
      os
    }
    toolGroups {
      category
      tools {
        description
        name
      }
    }
    updatedAt
    updatedBy
  }
}
` as GeneratedQuery<APITypes.ListMcpConfigsQueryVariables, APITypes.ListMcpConfigsQuery>;
export const listMyIntakeStories = /* GraphQL */ `query ListMyIntakeStories($limit: Int, $offset: Int) {
  listMyIntakeStories(limit: $limit, offset: $offset) {
    hasMore
    items {
      createdAt
      intake {
        applicationId
        applicationName
        assigneeAlias
        assigneeName
        createdAt
        hasAttachment
        hasMyUpvote
        intakeId
        owningTeam
        requestorAlias
        requestorName
        status
        storyCount
        title
        updatedAt
        upvoteCount
        usersImpacted
      }
      storyId
      storyText
      updatedAt
    }
    totalCount
  }
}
` as GeneratedQuery<APITypes.ListMyIntakeStoriesQueryVariables, APITypes.ListMyIntakeStoriesQuery>;
export const listPeopleByLeader = /* GraphQL */ `query ListPeopleByLeader($leaderAlias: String!) {
  listPeopleByLeader(leaderAlias: $leaderAlias) {
    alias
    createdAt
    isActive
    level
    name
    reportsTo
    title
    updatedAt
  }
}
` as GeneratedQuery<APITypes.ListPeopleByLeaderQueryVariables, APITypes.ListPeopleByLeaderQuery>;
export const listPolicyEngineDetail = /* GraphQL */ `query ListPolicyEngineDetail {
  listPolicyEngineDetail {
    policy_engine_details {
      data {
        create_date
        last_updated_at
        manager_login_hierarchy_concat
        manager_name_hierarchy_concat
        policy_class
        policy_type
        resolution_type
        resolved_date
        severity
        status
        team_name
        violation_entity_type
        violation_name
        violation_pretty_name
        violator_id
        violator_manager_login
        violator_manager_name
        violator_name
        violator_owner
        violator_owner_name
        violator_type
      }
      metadata {
        last_updated_at
      }
    }
  }
}
` as GeneratedQuery<APITypes.ListPolicyEngineDetailQueryVariables, APITypes.ListPolicyEngineDetailQuery>;
export const listPortfolioVotes = /* GraphQL */ `query ListPortfolioVotes($cycleId: ID!, $portfolioGid: ID!) {
  listPortfolioVotes(cycleId: $cycleId, portfolioGid: $portfolioGid) {
    budget
    cycleId
    items {
      hasMyNotRequired
      hasMyVote
      notRequiredCount
      projectGid
      voteCount
    }
    myNotRequiredCount
    portfolioGid
    projectCount
    totalNotRequired
    totalVotes
    votesRemaining
    votesUsed
  }
}
` as GeneratedQuery<APITypes.ListPortfolioVotesQueryVariables, APITypes.ListPortfolioVotesQuery>;
export const listProjectComments = /* GraphQL */ `query ListProjectComments($limit: Int, $offset: Int, $projectGid: ID!) {
  listProjectComments(limit: $limit, offset: $offset, projectGid: $projectGid) {
    hasMore
    items {
      authorAlias
      commentId
      commentText
      createdAt
      updatedAt
    }
    totalCount
  }
}
` as GeneratedQuery<APITypes.ListProjectCommentsQueryVariables, APITypes.ListProjectCommentsQuery>;
export const listProjectDetailsByAliases = /* GraphQL */ `query ListProjectDetailsByAliases(
  $aliases: [String!]!
  $fromWeek: String
  $toWeek: String
) {
  listProjectDetailsByAliases(
    aliases: $aliases
    fromWeek: $fromWeek
    toWeek: $toWeek
  ) {
    alias
    allocations {
      fte
      percent
      projectId
    }
    confirmed
    createdAt
    note
    updatedAt
    week
    year
  }
}
` as GeneratedQuery<APITypes.ListProjectDetailsByAliasesQueryVariables, APITypes.ListProjectDetailsByAliasesQuery>;
export const listProjectsByLeader = /* GraphQL */ `query ListProjectsByLeader($leaderAlias: String!) {
  listProjectsByLeader(leaderAlias: $leaderAlias) {
    additionalLeaders
    createdAt
    isActive
    isGlobal
    lead
    projectId
    projectName
    targetFte
    type
    updatedAt
  }
}
` as GeneratedQuery<APITypes.ListProjectsByLeaderQueryVariables, APITypes.ListProjectsByLeaderQuery>;
export const listSASDetail = /* GraphQL */ `query ListSASDetail {
  listSASDetail {
    sas_details {
      data {
        assignee_login
        assignee_name
        campaign_name
        has_recommendation
        is_blocked_campaign
        oldest_recommendation_age
        oldest_risk_age
        resource_name
        resource_type
        risk_status_at_eom
        snapshot_month
        supervisor_login_name_hierarchy
        supervisor_name_hierarchy
        team_name
      }
      metadata {
        last_updated_at
      }
    }
  }
}
` as GeneratedQuery<APITypes.ListSASDetailQueryVariables, APITypes.ListSASDetailQuery>;
export const listTeamPageContent = /* GraphQL */ `query ListTeamPageContent {
  listTeamPageContent {
    enableTeamInfoTabs
    id
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    sidePanelDetails {
      customSidePanelWidgets {
        contentType
        id
        isEnabled
        isExpandedByDefault
        richTextContent
        tableContent {
          displayName
          id
          link
          position
        }
        title
      }
      keyContacts {
        contentType
        isEnabled
        isExpandedByDefault
        richTextContent
        title
      }
      officeHours {
        contentType
        isEnabled
        isExpandedByDefault
        richTextContent
        title
      }
      supportLinks {
        contentType
        id
        isEnabled
        isExpandedByDefault
        richTextContent
        tableContent {
          displayName
          id
          link
          position
        }
        title
      }
    }
    teams {
      id
      teamIntroductionVideoUrl
      teamName
      teamOverView
      teamWelcomeDetails {
        description
        displayText
        id
        link
        pointOfContact
      }
    }
  }
}
` as GeneratedQuery<APITypes.ListTeamPageContentQueryVariables, APITypes.ListTeamPageContentQuery>;
export const listTestimonials = /* GraphQL */ `query ListTestimonials {
  listTestimonials {
    announcement_id
    announcement_name
    created_at
    is_active
    original_text
    summary
    testimonial_id
    testimonial_sequence
    updated_at
    users {
      badge_color
      business_title
      cost_center_name
      employee_status
      first_name
      job_status
      last_name
      legacy_employee_id
      login
      person_id
    }
  }
}
` as GeneratedQuery<APITypes.ListTestimonialsQueryVariables, APITypes.ListTestimonialsQuery>;
export const listTicketMetricDetail = /* GraphQL */ `query ListTicketMetricDetail {
  listTicketMetricDetail {
    ticket_details {
      data {
        application_name
        assigned_date
        assigned_to_group
        assigned_to_individual_name
        assignee_login
        case_id
        create_date
        impact
        last_modified_by
        manager_login_hierarchy_concat
        manager_name_hierarchy_concat
        modified_date
        resolution_type
        resolved_date
        short_description
        sim_issue_alias
        status
        team_name
        total_time_spent
      }
      metadata {
        last_updated_at
      }
    }
  }
}
` as GeneratedQuery<APITypes.ListTicketMetricDetailQueryVariables, APITypes.ListTicketMetricDetailQuery>;
export const listUserMetric = /* GraphQL */ `query ListUserMetric {
  listUserMetric {
    user_metrics_details {
      data {
        application
        application_type
        display_sub_application_name
        distinct_users
        last_updated_at
        log_month
        measure_value
        supervisor_login_name_hierarchy
        supervisor_name_hierarchy
        team_name
      }
      metadata {
        last_updated_at
      }
    }
  }
}
` as GeneratedQuery<APITypes.ListUserMetricQueryVariables, APITypes.ListUserMetricQuery>;
export const listVoteCycles = /* GraphQL */ `query ListVoteCycles($process: String, $status: String, $year: Int) {
  listVoteCycles(process: $process, status: $status, year: $year) {
    items {
      bannerHours
      budget
      closesAt
      createdAt
      createdBy
      cycleId
      isOpen
      name
      opensAt
      portfolios {
        isMain
        portfolioGid
        portfolioLabel
      }
      process
      status
      updatedAt
      updatedBy
      year
    }
    totalCount
  }
}
` as GeneratedQuery<APITypes.ListVoteCyclesQueryVariables, APITypes.ListVoteCyclesQuery>;
